import './index.scss';

function Footer() {

  return (
    <div className='footer'>
      <p>
        Feel free to contact me. 
      </p>
      © EizyC. All right reserved
    </div>
  );
}
export default Footer;